<template>
  <app-modal
      :modal-id="modalId"
      :title="title"
      :preloader="preloader"
      @submit="submit"
      @close-modal="closeModal"
      modal-size="large"
      modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{title}}</h5>
      <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="
          selectedUrl
            ? `/masterData/evaluatorScope/${inputs.id}`
            : `/masterData/evaluatorScope`
        "
      >
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="mb-0">
                {{ $t("accreditation_area") }}
              </label>
              <app-input
                  id="inputs_accreditation_area_id"
                  type="select"
                  v-model="inputs.area_id"
                  :list="accreditationAreaList"
                  v-on:change="onChangeAccreditationArea"
                  :required="true"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="mb-0">
                {{ $t("activity") }}
              </label>
              <app-input
                  id="inputs_accreditation_activity_id"
                  type="select"
                  v-model="inputs.activity_id"
                  :list="accreditationActivityLists"
                  :required="true"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label class="mb-0">Ingrese el alcance</label>
              <app-input
                  type="textarea"
                  v-model="inputs.scope"
                  placeholder="Ingrese el alcance"
                  :required="true"
              />
            </div>
          </div>

          <div class="col-12"  v-if="checkForVisibility">
            <div class="form-group">
              <label class="mb-0">Código  IAF/Subcategoria Alimentaria (DC)</label>
              <app-input
                  type="textarea"
                  v-model="inputs.code_iaf_subcategory"
                  placeholder="Ingrese el códgio IAF"
                  :required="false"
              />
            </div>
          </div>


          <div class="col-12" v-if="checkForVisibility">
            <div class="form-group">
              <label class="mb-0">Observaciones</label>
              <app-input
                  type="textarea"
                  v-model="inputs.observations"
                  placeholder="Ingrese las observaciones"
                  :required="false"
              />
            </div>
          </div>

        </div>
      </form>
    </template>

    <template slot="footer">
      <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>


  </app-modal>
</template>

<script>

import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin.js";
import {axiosGet} from "../../../../../../../resources/js/app/helpers/AxiosHelper";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
    accreditationAreaList: Array,
    accreditationActivityList: Array,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      disabled: false,
      modalId: "evaluator-scope-modal-add-edit",
      accreditationActivityLists: [],
      actvsInspExtra: []
    };
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    }
    this.getActvsExtra();
  },
  methods: {
    submit() {
      this.save(this.inputs);
    },
    afterSuccess(response) {
      if (this.selectedUrl != "") {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },
    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;

      this.onChangeAccreditationArea();
      this.preloader = false;
    },
    afterFinalResponse() {
      this.closeModal();
      this.preloader = false;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    onChangeAccreditationArea() {

      if (this.inputs.area_id){
        this.accreditationActivityLists = [
          { id: "", value: "Selecciona una opción" },
          ...this.accreditationActivityList.filter((item) => {
            return item.parent == this.inputs.area_id;
          }),
        ];
        if (this.inputs.area_id == 3){
          this.accreditationActivityLists = [...this.accreditationActivityLists, ...this.actvsInspExtra]
        }

      }else{
        this.accreditationActivityLists = [
          { id: "", value: "Selecciona una opción" }];
      }
    },
    getActvsExtra(){
      const url = `/masterData/evaluatorScope/actvs?area_id=3&is_active=0`;
      axiosGet(url).then(response=>{
        this.actvsInspExtra = response.data;
        this.onChangeAccreditationArea();
      })

    }
  },
  computed:{
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
    checkForVisibility() {
        const areaFound = this.accreditationAreaList.find(item => item.id == this.inputs.area_id);
        return areaFound && areaFound.value === 'CERTIFICACIÓN';
    }
  }
}
</script>
